// extracted by mini-css-extract-plugin
export default {"figure":"card_figure__a6uW4","picture":"card_picture__BQzEd","image":"card_image__Hko09"};